export const loginUserUseCase = async (userApi,values) => {
    try {
      const response =  await userApi.loginApi(values);
      return response;
    } catch (error) {
      throw new Error('Failed to login user');
    }
};